import './BecomeASellerOpenerSection.scss';
import { Typography, Button } from '@mui/material';
import WarningIcon from '@mui/icons-material/Warning';
import GpsFixedIcon from '@mui/icons-material/GpsFixed';
import FavoriteIcon from '@mui/icons-material/Favorite';
import DownArrow from '@mui/icons-material/ArrowDownwardRounded';
import { useNavigate } from 'react-router-dom';
import { SessionManager } from '../../../../services/SessionManager/SessionManager';

const BecomeASellerOpenerSection = () => {
  const navigate = useNavigate();

  const handleBreakFree = () => {
    const isLoggedIn = SessionManager.shared.isLoggedin();
    if (isLoggedIn) 
      navigate('/become-a-freelancer/register');
    else 
      navigate('/login');
  };

  const scrollToComparison = () => {
    const comparisonSection = document.querySelector('.become-freelancer-comparison');
    if (comparisonSection) {
      const elementPosition = comparisonSection.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - 60;
      
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <div className="become-freelancer-opener">
      <div className="opener-container">
        <div className="opener-content">

          {/* Left Section - Text Content */}
          <div className="text-section">
            {/* Top Tags */}
            <div className="top-tags">
              <div className="tag broken-tag">
                <WarningIcon className="tag-icon" />
                <span>Freelancing is Broken</span>
              </div>
              <div className="tag fixing-tag">
                <GpsFixedIcon className="tag-icon" />
                <span>We're Fixing It</span>
              </div>
            </div>

            {/* Main Headline */}
            <div className="headline">
              <Typography className="headline-main">
                Tired of Waiting Months
              </Typography>
              <Typography className="headline-accent">
                for Your First Order?
              </Typography>
            </div>

            {/* Value Proposition */}
            <Typography variant="h5" className="value-proposition">
              Stop competing with millions. Start earning from day one with our AI-powered geographic matching system.
            </Typography>

            {/* Made in India Callout */}
            <div className="made-in-india">
              <FavoriteIcon className="heart-icon" />
              <span>Proudly Handcrafted in India, because we value your talent. We understand your challenges because we've faced them too.</span>
            </div>

            {/* Call to Action Buttons */}
            <div className="cta-buttons">
              <Button 
                variant="contained" 
                className="primary-cta"
                size="large"
                onClick={handleBreakFree}
              >
                Register As A Freelancer
              </Button>
              <Button 
                variant="outlined" 
                className="secondary-cta"
                size="large"
                startIcon={<DownArrow />}
                onClick={scrollToComparison}
              >
                See How We're Different
              </Button>
            </div>
          </div>
          {/* Right Section - Visual */}
          <div className="visual-section">
            <div className="image-card">
              {/* Placeholder for main image */}
              <div className="main-image-placeholder">
                <div className="placeholder-content">
                    <img className='freelancer-img' src={require('../../../../assets/images/become_a_seller_page/new/freelancer_boi.jpg')} alt="Freelancer with laptop" />
                  {/* <Typography variant="h6" color="text.secondary">
                    Image Placeholder
                  </Typography> */}
                  {/* <Typography variant="body2" color="text.secondary">
                    Person working on laptop
                  </Typography> */}
                </div>
              </div>

              {/* Project Match Overlay */}
              <div className="project-match-overlay">
                <div className="match-dot"></div>
                <span>New project match found!</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BecomeASellerOpenerSection;
